export default {

    methods: {
        clientCode: function () {
            return window.location.href.split("//")[1].split(".")[0];
        },
    }
}